import { queryClient } from "@dashboard/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { I18nextProvider } from "react-i18next";
import type { ReactNode } from "react";
import { ThemeProvider } from "common-frontend-components";
import { SelectedCustomerContext } from "@dashboard/contexts/selectedCustomerContext";
import type { DashboardNavigation } from "@/api/sidebarEntryAPI";
import i18n from "@/i18n";

type HseAppProvidersProps = {
    selectedCustomerId?: number;
    dashboardNavigation?: DashboardNavigation;
    isDashboardNavigationPending: boolean;
    children: ReactNode;
};

export default function HseAppProviders({
    selectedCustomerId,
    dashboardNavigation,
    isDashboardNavigationPending,
    children,
}: HseAppProvidersProps) {
    return (
        <I18nextProvider i18n={i18n} defaultNS="hse">
            <QueryClientProvider client={queryClient}>
                <ThemeProvider defaultTheme="light">
                    <SelectedCustomerContext.Provider
                        value={{
                            selectedCustomerId,
                            dashboardNavigation,
                            isDashboardNavigationPending,
                        }}
                    >
                        {children}
                    </SelectedCustomerContext.Provider>
                    <ReactQueryDevtools />
                </ThemeProvider>
            </QueryClientProvider>
        </I18nextProvider>
    );
}
